import { orderHistoryTableStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistoryTable";

orderHistoryTableStyles.reorderButton = {
    color: "#8D1000",
    sizeVariant: "medium",
};
